import { RouteConfig } from 'vue-router';
import MswReportIssues from './msw-report-issues.vue';
import MswSignatureIssues from './msw-signature-issues.vue';
export const MswReportIssuesRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'reportissues',
  component: MswReportIssues,
};

export const MswSignatureIssuesRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'signIssues',
  component: MswSignatureIssues,
};
